__turbopack_context__.v({
  "bar": "audioIcon-module-scss-module__Gx3VTq__bar",
  "equalize": "audioIcon-module-scss-module__Gx3VTq__equalize",
  "equalizer": "audioIcon-module-scss-module__Gx3VTq__equalizer",
});
